import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Button } from 'reactstrap';
import windshield from '../../assets/img/bugzero/500-error.svg';

const Error500 = () => (
  // <Card className="text-center h-100">
  //   <CardBody className="p-5">
  //     <div className="display-1 text-200 fs-error">500</div>
  //     <p className="lead mt-4 text-800 text-sans-serif font-weight-semi-bold">Whoops, something went wrong!</p>
  //     <hr />
  //     <p>
  //       Try refreshing the page, or going back and attempting the action again. If this problem persists,
  //       <a href="mailto:info@exmaple.com" className="ml-1">
  //         contact us
  //       </a>
  //       .
  //     </p>
  //   </CardBody>
  // </Card>
  <>
    <Col sm={6} className="my-auto">
      <h1>Oooops !</h1>
      <h4 className="my-3">In life, sometimes you're the windshield, sometimes you are the bug</h4>
      <p className="lead">Looks like we are having some temporary issues with this request</p>
      <Link to={'/'}>
        <Button color="falcon-primary">Back to home</Button>
      </Link>
    </Col>
    <Col sm={6} className="my-auto">
      <img className="img-fluid mx-auto" src={windshield} alt="Bug or windshield" />
    </Col>
  </>
);

export default Error500;
